import React, { useState, useEffect, useContext } from 'react';
import './Info.css';
import { ReactComponent as LaunchIcon } from '../../assets/icons/launch-icon.svg';
import { ReactComponent as MailIcon } from '../../assets/icons/email-icon.svg';
import { ReactComponent as PrivacyIcon } from '../../assets/icons/password-icon.svg';
import { ReactComponent as TermsIcon } from '../../assets/icons/terms-icon.svg';
import { ReactComponent as WebsiteIcon } from '../../assets/icons/website-icon.svg';
import { ReactComponent as BlogIcon } from '../../assets/icons/blog-icon.svg';
import { ShowGettingStartedContext } from '../../objects/Context';

const Info = () => {

    const { showGettingStarted, setShowGettingStarted } = useContext(ShowGettingStartedContext);

    return (
        <div className='info-container'>
            <div className='vairo-info-container'>
                <h3 className='item-leader'>Help & Feedback</h3>
                <div className='item' onClick={() => {
                    setShowGettingStarted(true);
                }}>
                    <LaunchIcon className='item-icon' />
                    <h3 className='item-text'>Getting Started Guide</h3>
                </div>
                <div className='item' onClick={() => window.open('mailto:hello@vairo.ai', '_blank')}>
                    <MailIcon className='item-icon' />
                    <h3 className='item-text'>Contact</h3>
                </div>
            </div>
            <hr />
            <div className='vairo-info-container'>
                <h3 className='item-leader'>About</h3>
                <div className='item' onClick={() => window.open('https://vairo.ai/privacy', '_blank')}>
                    <PrivacyIcon className='item-icon' />
                    <h3 className='item-text'>Privacy Policy</h3>
                </div>
                <div className='item' onClick={() => window.open('https://vairo.ai/privacy', '_blank')}>
                    <TermsIcon className='item-icon' />
                    <h3 className='item-text'>Terms of Service</h3>
                </div>
                <div className='item' onClick={() => window.open('https://vairo.ai', '_blank')}>
                    <WebsiteIcon className='item-icon' />
                    <h3 className='item-text'>Website</h3>
                </div>
                <div className='item' onClick={() => window.open('https://vairo.ai/blog', '_blank')}>
                    <BlogIcon className='item-icon' />
                    <h3 className='item-text'>Blog</h3>
                </div>
            </div>
        </div>
    );
};

export default Info;
